import styled, { css } from "styled-components";
import { borderRadius, spacing } from "@magicbi/ui-library";

export const Strip = styled.span<{ $variant: "bars" | "swatches" }>`
  display: flex;
  gap: ${({ $variant }) => ($variant === "bars" ? spacing[0.5] : spacing[1])};
  ${({ $variant }) =>
    $variant === "bars"
      ? css`
          width: 100%;
          max-width: 9.5rem;
          height: 0.5rem;
        `
      : css`
          flex-wrap: wrap;
        `}
`;

/** The colour is data, drawn on a hairline so a white swatch still shows its edge. */
export const Sample = styled.i<{ $color: string; $variant: "bars" | "swatches"; $wide: boolean }>`
  display: block;
  background: ${({ $color }) => $color};
  box-shadow: inset 0 0 0 1px ${({ theme }) => theme.colors.border.stroke};
  ${({ $variant, $wide }) =>
    $variant === "bars"
      ? css`
          flex: 1;
          border-radius: ${borderRadius.xs};
        `
      : css`
          width: ${$wide ? "2.5rem" : "1.625rem"};
          height: 1.625rem;
          border-radius: ${borderRadius.md};
        `}
`;
